import { Loader2 } from "lucide-react";
import * as React from "react";
import _160_FFFFFF from "~/entrypoints/images/160_FFFFFF.gif";
import _320_FFFFFF from "~/entrypoints/images/320_FFFFFF.gif";

export const Splash: React.FC<{
  content?: React.ReactNode;
  progressiveBranded?: boolean;
}> = ({ content, progressiveBranded = false }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center"
      data-testid="splash"
    >
      <div className="flex flex-col items-center justify-center gap-4">
        {progressiveBranded ? (
          <>
            <img
              srcSet={`${_160_FFFFFF} 1x, ${_320_FFFFFF}`}
              src={_320_FFFFFF}
            />
          </>
        ) : (
          <Loader2 className="animate-spin text-progressive" />
        )}
        {content}
      </div>
    </div>
  );
};
